<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :minimalize="minimalize"
    :send-function="onSave"
    :open-function="onOpen"
    :width="$vuetify.breakpoint.smAndDown ? null : 900"
  >
    <div class="grid gap5">
      <BaseInput
        :label="t['persons']['imya']"
        v-model="data.first_name"
        :rules="['required', 'max50']"
      />
      <BaseInput
        :label="t['persons']['familiya']"
        v-model="data.last_name"
        :rules="['required', 'max50']"
      />
      <BaseInput
        :label="t['persons']['dolzhnost']"
        v-model="data.position"
        :rules="['max100']"
      />
      <BaseInput
        :label="t['persons']['elektronnaya-pochta']"
        v-model="data.email"
        :rules="['required', 'email', 'max50']"
      />
      <BaseInput
        :label="t['persons']['telefon']"
        type="tel"
        v-model="data.phone"
      />
    </div>
  </TemplateModal>
</template>

<script>

import {mapActions} from "vuex";

export default {
  name: 'WorkClientPersonModal',
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    create: Boolean,
    minimalize: Boolean,
    clientId: {
      type: [Number, String],
      default: null,
    }
  },
  data: () => ({
    dialog: false,
    data: {},
  }),
  computed: {
    t() {
      return this.localStorage.translations.pages['setting-client']
    },
    text() {
      return {
        button: {
          open: this.minimalize
            ? this.localStorage.translations.pages['common']['buttons']['dobavit']
            : this.t['persons-dialogs-add_edit-buttons']['dobavit-kontaktnoe-litso']
        },
        title: {
          create: this.t['persons-dialogs-add_edit']['dobavlenie-kontaktnogo-litsa'],
          edit: this.t['persons-dialogs-add_edit']['redaktirovanie-kontaktnogo-litsa']
        }
      }
    },
    params() {
      return {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
        id: this.$route.params.id,
      }
    }
  },
  methods: {
    ...mapActions('workClientPerson', [
      'onWorkClientPersonShow',
      'onWorkClientPersonCreate',
      'onWorkClientPersonGrid',
      'onWorkClientPersonUpdate',
      'onWorkClientPersonAllClient',
    ]),
    async onOpen() {
      if (this.id)
        await this.onWorkClientPersonShow(this.id)
          .then(res => {
            this.data = res.data.data
          })
      else
        this.data = {}
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
    },
    async onSave() {
      this.data.work_client_id = this.$route.name === 'clientsCompanyShow' ? this.$route.params.id : this.clientId
      if (this.data.id) {
        await this.onWorkClientPersonUpdate(this.data)
          .then(() => {
            this.onWorkClientPersonGrid(this.params)
          })
      } else {
        await this.onWorkClientPersonCreate(this.data)
          .then(() => {
            if (this.$route.name === 'clientsCompanyShow')
              this.onWorkClientPersonGrid(this.params)
            else
              this.onWorkClientPersonAllClient(this.clientId)
          })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    grid-template-columns: 1fr;
  }
}
</style>